import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../classes/tradePlan/tradePlanProvider';
import { RefactoredChartContainer } from '../../../../charts/d3/candlestickchart/newCandleChart/chartContainer/RefactoredChartContainer';
import { determineBrokerage } from '../../../../charts/d3/candlestickchart/newCandleChart/utils/initialValuesUtils';

type Props = {
  numberOfCandles: number;
  timeUnit: string;
  candleDuration: number;
  id: string;
  showCandleNumbers: boolean;
  autoSend: boolean;
};

export const TradingChart = observer(
  ({
    autoSend,
    numberOfCandles,
    timeUnit,
    candleDuration,
    id,
    showCandleNumbers,
  }: Props) => {
    const tradePlanForm: TradePlanData = useTradePlanFormStore();

    const size = 362;
    return (
      <div style={{ padding: '5px' }}>
        <RefactoredChartContainer
          autoSend={autoSend}
          tradePlanId="newTradePlan"
          symbol={tradePlanForm.symbol}
          dataSource={tradePlanForm.dataSource}
          brokerage={determineBrokerage(tradePlanForm.brokerage)}
          numberOfCandles={numberOfCandles}
          timeUnit={timeUnit}
          candleDuration={candleDuration}
          id={id}
          size={size}
          margin={4}
          showCandleNumbers={showCandleNumbers}
          startHour={9}
          startMin={30}
        />
      </div>
    );
  }
);
